  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      const overlay = this.querySelector('#CartDrawer-Overlay');
if (overlay) overlay.addEventListener('click', this.close.bind(this));

const continueBtn = this.querySelector('.drawer-continue-shopping, .dsc-continue');
if (continueBtn) continueBtn.addEventListener('click', this.close.bind(this));
      this.setHeaderCartIconAccessibility();
    }

    setHeaderCartIconAccessibility() {

      const cartLink = document.querySelector('#cart-icon-bubble');
if (!cartLink) return;
cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });

      const stickyCartLink = document.querySelector('#cart-icon-bubble-sticky');

      if (stickyCartLink) {
        stickyCartLink.setAttribute('role', 'button');
        stickyCartLink.setAttribute('aria-haspopup', 'dialog');
        stickyCartLink.addEventListener('click', (event) => {
          event.preventDefault();
          this.open(stickyCartLink);
        });
        stickyCartLink.addEventListener('keydown', (event) => {
          if (event.code.toUpperCase() === 'SPACE') {
            event.preventDefault();
            this.open(stickyCartLink);
          }
        });
      }
    }

    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);
      const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
      if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
      // here the animation doesn't seem to always get triggered. A timeout seem to help
      setTimeout(() => {
        this.classList.add('animate', 'active');
      });

      this.addEventListener(
        'transitionend',
        () => {
          const containerToTrapFocusOn = this.classList.contains('is-empty')
            ? this.querySelector('.drawer__inner-empty')
            : document.getElementById('CartDrawer');
          const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
          trapFocus(containerToTrapFocusOn, focusElement);
        },
        { once: true }
      );

      document.body.classList.add('overflow-hidden');
    }

    close() {
      this.classList.remove('active');
      if (this.activeElement && !this.activeElement.classList.contains('quick-add__submit')) {
        removeTrapFocus(this.activeElement);
      }
      document.body.classList.remove('overflow-hidden');
    }

    setSummaryAccessibility(cartDrawerNote) {
      cartDrawerNote.setAttribute('role', 'button');
      cartDrawerNote.setAttribute('aria-expanded', 'false');

      if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
        cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
      }

      cartDrawerNote.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
      });

      cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }

    renderContents(parsedState) {
      const drawerInner = this.querySelector('.drawer__inner');
      if (drawerInner && drawerInner.classList.contains('is-empty')) drawerInner.classList.remove('is-empty');
      this.productId = parsedState.id;

      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        if (sectionElement) {
          const newHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
          if (newHTML !== null) sectionElement.innerHTML = newHTML;
        }
      });

      this.classList.remove('is-empty');
      const cartDrawerItems = this.querySelector('cart-drawer-items');
      if (cartDrawerItems) {
        cartDrawerItems.classList.remove('is-empty');
        cartDrawerItems.style.removeProperty('display');
      }

    // Re-bind overlay after innerHTML swap (no timeout needed)
const overlay = this.querySelector('#CartDrawer-Overlay');
if (overlay) {
  overlay.addEventListener('click', this.close.bind(this));
}
const continueBtn = this.querySelector('.drawer-continue-shopping, .dsc-continue');
if (continueBtn) continueBtn.addEventListener('click', this.close.bind(this));
// open() is called by the caller — don't call it here
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      if (!html) return null;
      const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      return el ? el.innerHTML : null;
    }
    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer',
        },
        {
          id: 'cart-icon-bubble',
        },
        {
          id: 'cart-icon-bubble-sticky'
        }
      ];
    }
    getSectionDOM(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }
    setActiveElement(element) {
      this.activeElement = element;
    }
  }

  customElements.define('cart-drawer', CartDrawer);

  class CartDrawerItems extends CartItems {
    getSectionsToRender() {
      return [
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer__inner',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble', 
          selector: '.shopify-section',
        },
        {
          id: 'cart-icon-bubble-sticky',
          section: 'cart-icon-bubble-sticky',
          selector: '.shopify-section'
        }
      ];
    }
  }

  customElements.define('cart-drawer-items', CartDrawerItems);

  /* =========================================================================
    DS GLOBAL ADD-TO-CART → TOYO CART DRAWER INTEGRATION
    Works on homepage, collection, search — anywhere .ds-product__atc exists.
    ========================================================================= */
  (function() {
    if (window.__dsGlobalAtcInit) return;
    window.__dsGlobalAtcInit = true;

    // Toyo's cart drawer expects these section IDs for re-rendering
const SECTIONS_TO_RENDER = ['cart-drawer', 'cart-icon-bubble'];
    
    async function addToCart(button) {
      const variantId = button.dataset.variantId;
      const productTitle = button.dataset.productTitle || 'Product';
      if (!variantId) {
        console.error('[DS ATC] No data-variant-id on button', button);
        return;
      }

      const originalText = button.innerHTML;
      button.innerHTML = 'Adding...';
      button.disabled = true;
      button.dataset.loading = 'true';

      try {
        // 1. Add to cart with section rendering so Toyo's drawer updates
        const formData = {
          'items': [{ id: parseInt(variantId, 10), quantity: 1 }],
          'sections': SECTIONS_TO_RENDER.join(','),
          'sections_url': window.location.pathname
        };

        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/javascript'
          },
          body: JSON.stringify(formData)
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.description || 'Could not add to cart');
        }

        const data = await response.json();
        console.log('[DS ATC] Added:', productTitle, data);

        // 2. Update Toyo's cart drawer with returned section HTML
const cartDrawer = document.querySelector('cart-drawer');
if (cartDrawer && data.sections) {
  // Open drawer immediately — don't wait for DOM swap
  cartDrawer.open();
  // Then render contents without re-triggering open
  requestAnimationFrame(() => {
    const drawerInner = cartDrawer.querySelector('.drawer__inner');
    if (drawerInner) drawerInner.classList.remove('is-empty');
    cartDrawer.productId = variantId;
    cartDrawer.getSectionsToRender().forEach((section) => {
      const el = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (el && data.sections[section.id]) {
        const newHTML = cartDrawer.getSectionInnerHTML(data.sections[section.id], section.selector);
        if (newHTML !== null) el.innerHTML = newHTML;
      }
    });
    cartDrawer.classList.remove('is-empty');
    const cdi = cartDrawer.querySelector('cart-drawer-items');
    if (cdi) { cdi.classList.remove('is-empty'); cdi.style.removeProperty('display'); }
  });
}

        // 3. Success state on button
        button.innerHTML = '✓ Added';
        button.dataset.added = 'true';
        setTimeout(() => {
          button.innerHTML = originalText;
          button.disabled = false;
          delete button.dataset.loading;
          delete button.dataset.added;
        }, 1800);

      } catch (err) {
        console.error('[DS ATC] Error:', err);
        button.innerHTML = originalText;
        button.disabled = false;
        delete button.dataset.loading;
        showToast('Could not add to cart — please try again', 'error');
      }
    }

    async function refreshCartDrawerManually() {
      try {
        const res = await fetch('/?sections=cart-drawer,cart-icon-bubble');
        const sections = await res.json();
        if (sections['cart-drawer']) {
          const cartDrawerEl = document.querySelector('#CartDrawer');
          if (cartDrawerEl) {
            const parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
            const newInner = parsed.querySelector('#CartDrawer');
            if (newInner) cartDrawerEl.innerHTML = newInner.innerHTML;
          }
        }
        if (sections['cart-icon-bubble']) {
          const bubble = document.querySelector('#cart-icon-bubble');
          if (bubble) {
            const parsed = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
            const newBubble = parsed.querySelector('.shopify-section');
            if (newBubble) bubble.innerHTML = newBubble.innerHTML;
          }
        }
      } catch (e) {
        console.error('[DS ATC] Manual refresh failed:', e);
      }
    }

    function showToast(message, type) {
      let toast = document.querySelector('.ds-toast');
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'ds-toast';
        toast.innerHTML = '<span class="ds-toast__icon">✓</span><span class="ds-toast__msg"></span>';
        document.body.appendChild(toast);
      }
      toast.querySelector('.ds-toast__msg').textContent = message || 'Added to cart';
      if (type === 'error') {
        toast.dataset.type = 'error';
        toast.querySelector('.ds-toast__icon').textContent = '⚠';
      } else {
        delete toast.dataset.type;
        toast.querySelector('.ds-toast__icon').textContent = '✓';
      }
      toast.classList.add('is-visible');
      clearTimeout(toast._hideTimer);
      toast._hideTimer = setTimeout(() => toast.classList.remove('is-visible'), 3000);
    }

    // Event delegation — catches clicks on ALL .ds-product__atc buttons site-wide
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.ds-product__atc');
      if (!btn) return;
      if (btn.disabled || btn.dataset.loading === 'true') return;
      if (!btn.dataset.variantId) return;

      e.preventDefault();
      e.stopPropagation();
      addToCart(btn);
    });

    console.log('[DS ATC] Global AJAX cart handler initialized');
  })();